// DOM
import OcmMessenger from "ocm_mercurius_messenger";
import { messengerPublicationTypes } from "@ocm/services/services.constants.js";

const secondaryNavItemsClass = ".js-secondary-nav__item";
let $secondaryNav;
let $secondaryNavLinks;

function init() {
	$secondaryNavLinks = $(".js-secondary-nav a");
	$secondaryNav = $(".js-secondary-nav");

	// React to Route Changes
	OcmMessenger.subscribe(messengerPublicationTypes.ROUTE_CHANGE, () => {
		removeActiveClass();
		closeFlyout();
	});

	// eslint-disable-next-line prefer-arrow-callback
	$secondaryNavLinks.on("click", function () {
		$(this).closest(secondaryNavItemsClass).addClass("is-active");
	});
}

const removeActiveClass = () => {
	$secondaryNav.find(".is-active").removeClass("is-active");
};

const closeFlyout = () => {
	$(secondaryNavItemsClass).removeClass("is-open");
};

export { init };
